import React from "react";
var defaultTranslationFunction = function (input) { return input; };
var TranslationContext = React.createContext(defaultTranslationFunction);
export default TranslationContext;
